<template>
  <div>
    <!-- 提报人信息 -->
    <div class="trade-order-block">
      <div class="block-title">提报人信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <!-- 提报人 -->
          <el-col :span="3">提报人</el-col>
          <el-col :span="9">
            {{ tradeApplyInfoVO.applyClientLevelName || '' }} - {{ tradeApplyInfoVO.applyClientName }}
          </el-col>

          <!-- 所属区域 -->
          <el-col :span="3">所属区域</el-col>
          <el-col :span="9">
            {{ tradeApplyInfoVO.applyClientRegionName }}
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3" v-if="tradeApplyInfoVO.applyParentClientName">提报人上级</el-col>
          <el-col :span="9" v-if="tradeApplyInfoVO.applyParentClientName">
            {{tradeApplyInfoVO.applyParentClientLevel}} - {{ tradeApplyInfoVO.applyParentClientName}}
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 门店基本信息 -->
    <div class="trade-order-block">
      <div class="block-title">门店基本信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.pocName" label="门店名称" />
          <BaseCell :value="basePocInfo.channelName" label="渠道" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="String(basePocInfo.beesPocFlag) === '1' ? '交易门店' : '非交易门店'" label="门店类型" v-if="isPerfect" />
          <BaseCell :value="basePocInfo.subChannelName" label="子渠道" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.pocLocalName" label="地理位置" />
          <BaseCell :value="basePocInfo.businessChannelName" label="业务渠道" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.pocAreaName" label="门店特征" />
          <BaseCell :value="basePocInfo.averageFee" label="人均消费" numberFormat valueUnit="元" />
        </el-row>
        <el-row class="content-row" v-if="applyTypeName && execTypeSub !== '108' && execTypeSub !== '109'">
          <BaseCell :value="tradeApplyBaseVO.keyContactPerson" :label="`执行人姓名`" />
          <BaseCell :value="tradeApplyBaseVO.keyContactPhone" :label="`执行人电话`" />
        </el-row>
        <!-- <el-row class="content-row">
          <BaseCell :value="basePocInfo.zxhPocId" label="ICircleID" allCell />
        </el-row> -->
        <el-row class="content-row" v-if="applyTypeName && execTypeSub !== '108' && execTypeSub !== '109'">
          <BaseCell  v-if="String(basePocInfo.beesPocFlag) === '1'" :value="basePocInfo.beesWsL1Name" label="一批经销商名称" />
          <BaseCell v-else :value="basePocInfo.wsL1Name" label="一批经销商名称" />
        </el-row>
        <el-row  class="content-row">
          <BaseCell v-if="execTypeSub !== '108' && execTypeSub !== '109'" :value="basePocInfo.annualTotalSale" label="门店啤酒年销量" numberFormat valueUnit="箱" />
          <BaseCell v-if="basePocInfo.zxhPocId" :value="basePocInfo.wccsId" label="WCCSID" />
          <BaseCell v-else-if="tradeApplyBaseVO" :value="tradeApplyBaseVO.wccsId" label="WCCSID" />
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <BaseCell :value="basePocInfo.annualAbiSale" label="ABI啤酒年销量" numberFormat valueUnit="箱" allCell />
        </el-row>
        <el-row class="content-row">
          <BaseCell v-if="execTypeSub !== '108'" :value="basePocInfo.annualBudSale" label="- 百威啤酒年销量" subCell numberFormat valueUnit="箱" />
          <BaseCell :value="isPbo" label="是否ABI买店" />
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <BaseCell :value="basePocInfo.annualAdvanceSale" label="- 哈啤/雪津啤酒年销量" subCell allCell numberFormat valueUnit="箱" />
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <BaseCell :value="basePocInfo.annualPremiumSale" label="- 超高端啤酒年销量" subCell allCell numberFormat valueUnit="箱" />
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门店照片</el-col>
          <el-col :span="21"
            v-viewer="{movable: true}"
            class="info-img"
          >
            <div v-if="pocImageList.length">
              <div class="img-wrapper" v-for="img in pocImageList" :key="img.title">
                <img :src="getImg(img.imageUri)" />
                <div class="img-wrapper-title">{{ img.title }}</div>
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <BaseCell :value="getImg(basePocInfo.bizLicensePhotoUri)" label="营业执照" isImg />
          <BaseCell :value="getImg(basePocInfo.dianpinImageUri)" label="大众点评/美团/饿了么截图" isImg />
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <el-col :span="3">补充资料</el-col>
          <el-col :span="21"
            v-viewer="{movable: true}"
            class="info-img"
          >
            <div v-if="basePocInfo.pocImageList && basePocInfo.pocImageList.length">
              <div class="img-wrapper" v-for="img in basePocInfo.pocImageList" :key="img.pocImageId">
                <img :src="getImg(img.imageUri)" />
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="`${basePocInfo.provinceName || ''} ${basePocInfo.cityName || ''} ${basePocInfo.countyName || ''} ${basePocInfo.detailAddress || ''}`" label="门店地址" allCell />
        </el-row>
      </div>
      <div class="block-content">
        <el-row class="content-row">
          <div id="content-map"></div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import BaseCell from '@/components/base-cell'
export default {
  name: 'poc-base-info',
  components: {
    BaseCell
  },
  props: {
    tradeApplyOrderVO: {},
    tradeApplyInfoVO: {},
    basePocInfo: {},
    tradeApplyBaseVO: {},
    applyTypeName: {
      type: String,
      default: ''
    },
    tradeApplyExecVO: {}
  },
  data () {
    return {
      pocImageList: []
    }
  },
  computed: {
    isPbo () {
      if (this.basePocInfo.isPbo === null) return this.basePocInfo.isPbo
      return this.basePocInfo.isPbo ? '是' : '否'
    },

    execTypeSub () {
      if (this.tradeApplyExecVO) {
        return this.tradeApplyExecVO?.execTypeSub
      }
      return ''
    },
    isPerfect () {
      if (this.tradeApplyOrderVO?.tradeApplyExecPerfectVOList && this.tradeApplyOrderVO.tradeApplyExecPerfectVOList.length) {
        return true
      }
      return false
    }
  },
  created () {

  },
  methods: {
    initMap (info) {
      this.pocImageList = []
      // 售点照片
      if (this.basePocInfo.pocOutsidePhotoUri) {
        this.pocImageList.push({ title: '门头照', imageUri: info.pocOutsidePhotoUri })
      }
      if (this.basePocInfo.pocExternalPhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({ title: '外部整体', imageUri: info.pocExternalPhotoUri })
      }
      if (this.basePocInfo.pocInsidePhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({ title: '内部整体', imageUri: info.pocInsidePhotoUri })
      }
      if (this.basePocInfo.pocStreetPhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({ title: '外部街区', imageUri: info.pocStreetPhotoUri })
      }

      const { locLatitude, locLongitude, pocName } = info
      if (!locLatitude || !locLongitude) return
      const map = new AMap.Map('content-map', {
        center: [locLongitude, locLatitude],
        zoom: 16
      })
      const position = new AMap.LngLat(locLongitude, locLatitude)
      const marker = new AMap.Marker({position, map})
      const handleMapClick = AMap.Event.addListener(map, 'click', () => {
        window.open(`https://uri.amap.com/marker?position=${locLongitude},${locLatitude}&name=${pocName}&src=尊享先锋订单平台`)
      })
    },

    getImg (uri) {
      if (!uri) return null
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
#content-map {
  width: 450px;
  height: 200px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
